const ERROR_MESSAGES = Object.freeze({
  bundle_invalid: 'Die ausgewählte Reservierungskette ist ungültig. Bitte lade die Vorschläge neu.',
  bundle_member_unavailable: 'Mindestens eine Reservierung ist nicht mehr verfügbar. Bitte lade die Vorschläge neu.',
  bundle_member_in_ready_window: 'Mindestens eine Reservierung liegt bereits im Bereitschaftsfenster und kann nicht mehr als Kette zugewiesen werden.',
  driver_not_eligible: 'Der gewählte Fahrer oder sein Fahrzeug ist für mindestens eine Fahrt nicht geeignet.',
  reservation_chain_conflict: 'Die Fahrten passen zeitlich nicht konfliktfrei in den Plan dieses Fahrers.',
  bundle_atomic_required: 'Diese Reservierungskette kann nur als Ganzes neu zugewiesen werden.',
  routing_unavailable: 'Die Erreichbarkeit kann gerade nicht sicher berechnet werden. Bitte versuche es später erneut.',
  reservation_state_changed: 'Die Reservierungskette wurde zwischenzeitlich geändert. Bitte lade den aktuellen Stand neu.',
  customer_blocked: 'Dieser Fahrer hat einen der Fahrgäste blockiert und kann die Kette nicht übernehmen.',   // FAHRGAST-BLOCKIEREN-001
});

export async function assignChainAtomic(api, { rideIds, driverId, expectedState }) {
  const body = {
    ride_ids: rideIds,
    driver_id: driverId,
  };
  if (expectedState) body.expected_state = expectedState;
  const response = await api.post('/partners/reservation-chains/assign', body);
  return response.data;
}

export function bundleErrorMessage(error) {
  const code = error?.response?.data?.error;
  return ERROR_MESSAGES[code]
    || 'Die Zuweisung ist fehlgeschlagen. Bitte prüfe den aktuellen Stand.';
}

export { ERROR_MESSAGES };
